module.exports = __webpack_public_path__ + "img/wagon_stopped.51e102f9.svg";